import { render, staticRenderFns } from "./Referentiel.vue?vue&type=template&id=0fb50f40&"
import script from "./Referentiel.vue?vue&type=script&lang=js&"
export * from "./Referentiel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports